// Translation: Account > Billing > Statistics (Arabic)
export default Object.freeze({
	cards: {
		endOfThisMonth: {
			fields: {
				balance: '',
				expenses: '',
				revenue: ''
			},
			title: ''
		},
		lastMonth:{
			fields: {
				balance: '',
				expenses: '',
				revenue: ''
			},
			title: ''
		},
		monthToDate: {
			fields: {
				balance: '',
				expenses: '',
				revenue: ''
			},
			title: ''
		}
	},
	fallback: {
		unavailable: ''
	},
	title: ''
})
